/*
Copyright 2019 Raphael Pereira <raphaelpereira@gmail.com>
Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at
    http://www.apache.org/licenses/LICENSE-2.0
Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/

'use strict';

(function DocumentManager() {
    let dataURItoBlob = dataURI => {
        let mime = dataURI.split(',')[0].split(':')[1].split(';')[0];
        let binary = atob(dataURI.split(',')[1]);
        let array = [];
        for (let i = 0; i < binary.length; i++) {
            array.push(binary.charCodeAt(i));
        }
        return new Blob([new Uint8Array(array)], {type: mime});
    };

    let context = {};
    let setUrl = elmInfo => {
        if (elmInfo == null) return;
        if (elmInfo.name == null) return;
        if (elmInfo.content == null) return;
        if (elmInfo.mime == null) return;
        if (context[elmInfo.name]) {
            URL.revokeObjectURL(context[elmInfo.content]);
        }
        if (elmInfo.content.includes("https://") || elmInfo.content.length < 1024*1024) {
            elmInfo.objectUrl = elmInfo.content
        } else {
            context[elmInfo.name] = URL.createObjectURL(dataURItoBlob(elmInfo.content));
            elmInfo.objectUrl = context[elmInfo.name];
        }
        app.ports.documentUrlHasBeenSet.send(elmInfo);
    };

    let clearUrl = elmInfo => {
        URL.revokeObjectURL(context[elmInfo.name]);
        delete context[elmInfo.name];
    };

    let clearUrls = () => {
        for (let name of Object.keys(context)) {
            URL.revokeObjectURL(context[name]);
        }
        context = {};
    };


    let uploadDocumentToS3 = (doc) => {
      console.log ("uploadDocumentToS3");
      var presignedPostUrl = doc.objectUrl;
      var fileType = doc.mime;
      var fileContents = doc.content;
      try {

        return fetch(doc.content).then(r => {
          fileContents = new File([r.blob()], presignedPostUrl.split("/")[3].split("?")[0], { type: fileType});
          return fetch(presignedPostUrl, {
            method: 'PUT',
            body: fileContents
          }).then(e => {
            app.ports.uploadFailed.send("00000000-0000-0000-0000-000000000000");
          }).catch (e => {
            console.log("error");
            console.log(e);
            app.ports.uploadFailed.send(doc.Id);
          });
        });
      }catch(e){
        console.log(e);
        app.ports.uploadFailed.send(doc.Id);

      }
    
    };

    if (app.ports.documentRequestUrl) {
        app.ports.documentRequestUrl.subscribe(setUrl);
    }

    if (app.ports.documentClearUrl) {
        app.ports.documentClearUrl.subscribe(clearUrl);
    }

    if (app.ports.documentClear) {
        app.ports.documentClear.subscribe(clearUrls);
    }

    if (app.ports.uploadToS3) {
      app.ports.uploadToS3.subscribe(uploadDocumentToS3);
    }

})();
